














































































































































import { BASE_HOST } from "@/plugins/axios";
import { HELPER } from "@/utils/Helper";
import { UserInterface } from "@/utils/UserInterface";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";



export class Signie{
	public Topaz: string = '';
	public Std: string = '';
}


declare function ClearTablet();
declare function SetDisplayXSize(a:any);
declare function SetDisplayYSize(a:any);
declare function SetTabletState(a:any, b:any, c?:any);
declare function SetJustifyMode(a:any);
declare function GetSigString();
declare function SetSigString(a:any);
declare function GetSigImageB64(callback);

@Component({
  components: {},
})
export default class SignaturePanel extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
	beforeDestroy(){
		console.log("Before destroy invoked...");
		clearInterval(this.itv1__);
		clearInterval(this.itv2__);
		ClearTablet();
		SetTabletState(0, this.tmr__);
	}

	private itv1__: number =0;
	private itv2__: number =0;
	mounted(){

		
	 this.itv1__ =	setInterval(()=>{

			if (!this.setup)return;

			// console.log(this.$refs.jatajata[0], this.$refs.jatajata);
			var isIt = this.isVisible( this.$refs.vizcheck );
			// console.log("am i visible ? ", isIt);

			// this.everything = isIt;

			if (isIt)
			{
				if (this.setup==true && !this.everything){
					this.everything = true;
					console.log("entered into visibility");

					/*
					EXIT THIS METHOD SO ANY FURTHER PROCESSING 
					OCCURS ON THE NEXT ITERATION.  
					*/
					// return;
				}

				var sig: Signie = new Signie();
				if (this.buf1 != null){
					console.log("processing buffer 1", this.buf1);
					sig = HELPER.Clone( this.buf1);
					this.SetSignature(sig);
				}

				if (this.buf3==null){
					// console.log("No buf3 set");						
				}else{
					this.SetPadStatus(this.buf3);
				}

				this.$nextTick(()=>{
				this.buf1 = null;
				this.buf3 = null;
				});

			}else{
				if (this.everything){
					this.everything = false;
					console.log("lost visibility");
				}
			}

		}, 2000);



		/* INTRODUCING A FAKE DELAY */
		// var delay: number = 1;
		var callback = (topazIsSupported: boolean) => {

		// console.log('b');

		// setTimeout(()=>{
			this.topazSupported = topazIsSupported;
			// console.log('ready!');

			/* IF THERE IS A VALUE IN THIS BUFFER, USE IT */
			// if (this.buf2 != -1){
			// 	wantedSigpad = this.buf2;

			// 	console.log('wanted Sigpad', wantedSigpad);
			// }

			/* IF TOPAZ IS NOT SUPPORTED, NO PROBLEM */
			// if (!this.topazSupported){
			// 	wantedSigpad = 0;
			// }

			// var sig: Signie = new Signie();
			// if (this.buf1 != null){
			// 	console.log("processing buffer 1", this.buf1);
			// 	sig = HELPER.Clone( this.buf1);
			// }

			// if (!this.topazSupported && this.hideIfUnsupported)
			// {
			// 	this.canSwitch = false;
			// }


			/* 
			HACK: NEED TO SET THE "VueSignaturePad" 
			VISIBLE JUST FOR A BIT, 
			OTHERWISE IT WILL NOT WORK. 
			*/
			// this.sigpad__ = 0;


			this.$nextTick(()=>{

				if (this.topazSupported){
					this.InstantiateTopazPad();
					this.CaptureTopazSignaturePeriodically();
				}else{
					// console.log("Downgrading data to std sigpad");
				}

				// this.sigpad__ = wantedSigpad;

					// this.everything = true;
					this.setup = true;

				// this.$nextTick(()=>{

				// // setTimeout(()=>{
				// 	console.log("... delay completed...");
				// 	this.SetSignature(sig);

				// 	if (this.buf3==null){
				// 		console.log("No buf3 set");						
				// 	}else{
				// 		this.SetPadStatus(this.buf3);
				// 	}

				// // },2000);

				// })

			});


		};


		// new Promise((v)=>{
			// console.log("promising...");
			this.Iterate(callback);
			// .then(()=>{
			// console.log("done...");
			// });
		// // 	console.log("promised");
		// }).then(()=>{
		// });


		// if (document.readyState === 'complete') {
		// 	callback();
		// } else {
		// 	window.addEventListener("load", callback);
		// }
	}


	private isVisible(ele:any): boolean {
			// return element && ( 
			// 		element.clientHeight !== 0 ||
			// 		element.getClientRects().length !== 0 ||
			// 		getComputedStyle(element).display !== 'none'
			// );

			return  ele.clientWidth !== 0 &&
    ele.clientHeight !== 0 &&
    (ele.style.opacity !== '' ? parseFloat(ele.style.opacity) > 0 : true);

	}


	private iterations__: number = 0;
	private maxIterations__: number = 20;
	private async Iterate(continueCallback: (supported:boolean)=>void)
	{
		/*
		THIS METHOD WILL TRY TO IDENTIFY IF THE COMPUTER HAS 
		A SIGWEB TABLET, USING A METHOD CALLED GetSigString();

		BUT THIS CAN FAIL IF THE PAGE DIDN'T LOAD IN FULL, 
		OR IF THERE IS NOT SIGNATURE PAD.

		THEREFORE WE NEED TO ACCOUNT FOR DIFFERENT SCENARIOS.
		*/

// var uri =makeUri();
// this.axios.get('tablet.sigwebtablet.com:47289/SigWeb/SigString');


// 		return;

		try{
			GetSigString();
			continueCallback(true);
		}
		catch(errr){

			var msg = (errr!=null)? errr.toString().toLowerCase():"";

			if (msg.indexOf('tablet.sigwebtablet.com')>-1){
				/* 
				TOPAZ NOT SUPPORTED
				Failed to execute 'send' on 'XMLHttpRequest': Failed to load 'http://tablet.sigwebtablet.com:47289/SigWeb/SigString'. 
				*/
				continueCallback(false);
			}else if (msg.indexOf('getsigstring is not defined')>-1){
				/* 
				THE PAGE DIDN'T LOAD IN FULL OUR SIGWEB SCRIPT.
				NEED TO REITERATE A FEW MORE TIMES:
				ReferenceError: GetSigString is not defined
				*/
				if (this.iterations__ > this.maxIterations__){
					/*
					WE ITERATED TOO MANY TIMES UNSUCCESSFULLY. 
					GIVING UP.
					*/
					console.log("Unable to load sigwebtable scripts :(");
					continueCallback(false);
				}else{
					this.iterations__++;
					setTimeout(()=>{
						this.Iterate(continueCallback);
					} , 500);
				}
			}else{
				console.log("UNEXPECTED ERROR: ", errr);
				continueCallback(false);
			}
			
		}

	}



  /* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  @Prop({default: false})
  public disabled: boolean;

  @Prop()
  public value: Signie;


  /* PRIVATE VARIABLES, __ POSTFIXED */
  private signa__: Signie = new Signie();
  private tmr__: string;
	private sigpad__: number = 0;
	
	private setup:boolean = false;
	private everything:boolean = false;
	
	private disabled__: boolean = false;

	private buf1: Signie = null;
	private buf3?: boolean = null;

	public sigpadW:number = 550;
	public sigpadH:number = 295;


	/* IDEAL VALUE IS "true"
	USES "false" FOR TESTING PURPOSES ONLY. 
	 */
	private hideIfUnsupported: boolean = false;


  /* VUE DATA */
  public options = {
    penColor: "white",
    backgroundColor: "rgba(0,0,0,0)",
    onEnd: this.onEnd,
  };

	public topazSupported: boolean = false;

	public canSwitch: boolean = true;


  /* VUE WATCH */
  @Watch("disabled", {immediate:true})
  onDisableChanged(newVal: boolean, oldVal: boolean) {

		if (!this.everything){
			this.buf3 = newVal;
			return;
		}

		this.SetPadStatus(newVal);
	}


	private SetPadStatus(disabled: boolean){

		console.log("Set pad status disabled? ", disabled);
		// return;
		this.disabled__ = disabled;

	}




  @Watch("value", {immediate:true})
  onValueChanged(newVal: Signie, oldVal: Signie) {

		// console.log("incoming signature...", newVal);

		if (newVal==null || newVal==undefined)
			newVal = new Signie();

		/* KEEP THINGS IN A BUFFER */
		if (!this.everything){
			this.buf1 = HELPER.Clone( newVal);
			return;
		}


		this.$nextTick(()=>{
			this.SetSignature(HELPER.Clone( newVal));
		});
	}


  /* VUE COMPUTED METHODS */
  get GetSigWebTableScript(): string {
		var rval =  BASE_HOST + "/specdev/rimguardraleigh/rimraleigh_admin_client/res/SigWebTablet.js";
		return rval;
	}

  /* PRIVATE METHODS */


  /* VUE METHODS */
	// public IsTopazSupported():boolean{

	// 	try{
	// 			GetSigString();
	// 			console.log("Topaz is supported !");
	// 			return true;
	// 	}catch(errr){
	// 		console.log("Topaz not be supported", errr);
	// 		return false;
	// 	}
	// }


	public SwitchPad():void{
		if (this.sigpad__==0){
			this.sigpad__ = 1;
		}else{
			this.sigpad__ = 0;
		}
		window.localStorage.setItem("rgr-sigpad", this.sigpad__.toString() );
	}

  onEnd() {
		// console.log("... Handling signature change.")
    const { data } = (this.$refs.signaturePad as any).saveSignature();

    this.signa__.Std = data;

		/* SINCE WE ARE DRAWING ON THE STD PAD, WE WANT TO 
		CLEAR THE TOPAZ DATA */
		this.signa__.Topaz = '';
		
		if (this.topazSupported){
			console.log("SetSigString to null");
			SetSigString('');
		}

		this.$emit('input', this.signa__);
		this.$emit('change');
  }



  public SetSignature(signa: Signie): void {
    console.log("setting signature requested");

		if (signa.Std==this.signa__.Std
				&& signa.Topaz==this.signa__.Topaz){
				console.log("No changes detected, rejecting update");
				return;
		}

		this.signa__ = signa;

		var signstrStd = '';
		var signstrTopaz = '';



		/* WE HAVE A TOPAZ SIGNATURE HERE, AND TOPAZ IS SUPPORTED 
		*/
		if (signa.Topaz!=null && signa.Topaz.length>0){
			// console.log("(i) We have a Topaz signature");

			if (this.topazSupported)
			{
				// console.log("- And Topaz is supported.");
				this.sigpad__ = 1;
				signstrTopaz = signa.Topaz;
				signstrStd = signa.Std;
			}else{
				// console.log("- But Topaz IS NOT supported");
				this.sigpad__ = 0;
				signstrStd = signa.Std;
			}
		}else{
			if (signa.Std!=null && signa.Std.length>0)
			{
				// console.log("(i) We have an Std signature");
				this.sigpad__ = 0;
				signstrTopaz = '';
				signstrStd = signa.Std;
			}else{
				// console.log("(i) We weren't given a signature :(");

				/* SET THE FAVORITE SIGPAD HERE ??? */
				var item = 	window.localStorage.getItem("rgr-sigpad");
				var wantedSigpad = parseInt(item);

				if (isNaN(wantedSigpad)){
					/* NO SPECIFIC SIGPAD SPECIFIED */
					wantedSigpad = this.topazSupported ? 1: 0;
				}else{
					// console.log('default sigpad specified:', wantedSigpad);
					
					if (wantedSigpad==1 && !this.topazSupported)
						wantedSigpad = 0;
				}

				// console.log("Preferred sigpad: ", wantedSigpad);
				this.sigpad__ = wantedSigpad;
			}
		}


		// if (signstrStd.length==0 || signstrTopaz.length==0){
		// 	// console.log("No signature to draw");
		// 	return;
		// }


		if (signstrStd.length > 0){
			console.log('setting sig 0');
      (this.$refs.signaturePad as any).fromDataURL(signstrStd);
			// console.log("No signature to draw");
			// return;
		}


		if (signstrTopaz.length>0)
		{
			ClearTablet();

			setTimeout(()=>{

			console.log('setting sig 1');
			// console.log("Clear tablet and set new signa", signstrTopaz.substr(0, 10));
				// this.$nextTick(()=>{
					SetSigString(signstrTopaz);
				// });
			}, 200);
		}

    // this.$emit("input", signa);
	}


  public InstantiateTopazPad() {

    var cnv = this.$refs.cnv as any;
    var ctx = cnv.getContext("2d");

    // console.log("Instantiating topaz pad...", cnv, ctx);

    SetDisplayXSize(550);
    SetDisplayYSize(295);

    SetTabletState(0, this.tmr__);
    SetJustifyMode(0);

		ClearTablet();

    /// OPENING THE TABLET
    this.tmr__ = SetTabletState(1, ctx, 50) || this.tmr__;

		// console.log("Table might be open...", this.tmr__);
	}


	private lastTopazSig: string = '';
	private CaptureTopazSignaturePeriodically()
	{
    // setTimeout( ()=> {
      // console.log("grabbing signature");

      /// CAPTURING THE SIGNATURE ON AN INTERVAL BASIS,
      /// WHY? BECAUSE ON UNLOAD IT MIGHT BE TOO LATE,
      /// WE WOULD HAVE TO WAIT ON AJAX CALLS TO COMPLETE.
      ///
      this.itv2__ = setInterval( ()=> {

				GetSigImageB64((img)=>{

					/* IF THE SIGPAD IS NOT TOPAZ,
					BUT TOPAZ IS SUPPORTED, THIS METHOD WILL STILL BE 
					CALLED PERIODICALLY, THEREFORE WE NEED TO DO 
					NOTHING WHEN IT'S CALLED, BECAUSE THE DATA WILL BE
					USED FROM A DIFFERENT SIGNATURE PAD.
					*/
					// if (this.sigpad__ == 0) return;

        	var topazSign = GetSigString();

					if (topazSign == this.lastTopazSig){
						// console.log("topaz sig didn't change, ignoring task");
						return;
					}
					this.lastTopazSig = topazSign;

					if (topazSign == '0000'){
						/* THIS IS NOTHING. 
						*/
						return;
					}

					var m = img;

					if (m!=null && m.length>0)
						m ='data:image/png;base64,'+ m;

					this.signa__.Topaz = topazSign;
					this.signa__.Std = m;

					/*
					IF WE RECEIVED A SIGNATURE, WE NEED
					TO SWITCH TO THIS PAD. 
					*/
					if (this.sigpad__!=1){
						// console.log("Switch to topaz pad so the sig is visible");
						this.sigpad__ = 1;
					}


					/* ALSO UPDATE THE OTHER PAD */
					console.log("drawing for sigpad 0", m);
      		(this.$refs.signaturePad as any).fromDataURL(m);

					this.$emit('input', this.signa__);
					this.$emit('change');
				});



      }, 3000);

	}


	// private ClearAndSetSignaturePad0(signstr: string){

	// 	/* CLEARING ONE SIGPAD */
  //   (this.$refs.signaturePad as any).clearSignature();

	// 	this.$nextTick(()=>{
  //     (this.$refs.signaturePad as any).fromDataURL(signstr);
	// 	});
	// }



  public ClearSignature(sigpad: number): void {

		/* CLEARING ONE SIGPAD */
    (this.$refs.signaturePad as any).clearSignature();

		/* CLEARING THE OTHER  SIGPAD */
		if (this.topazSupported)
      ClearTablet();

    this.signa__.Topaz = '';
    this.signa__.Std = '';

    this.$emit("input", this.signa__);
		this.$emit('change');
  }

}
